import { apiRequest } from '@/utils/api-request';

export const generateGuardrailsConfig = async (description: string) => {
  const response = await apiRequest({
    url: '/guardrails/create-guardrail-config-from-description',
    method: 'POST',
    target: 'platform',
    body: {
      description,
    },
  });

  if (response?.detail) {
    return {
      detail: response.detail,
    };
  }

  return response;
};
